import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';


@Injectable()

export class NotificationService {
  constructor(public snackBar: MatSnackBar) {
  }
  showUpdateNotification() {
      this.snackBar.open('ola');
  }

  notify(message, status = 'success') {
    return this.snackBar.open(message, null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'center', panelClass: [status]});
  }
}
